export const isServer = () => {
  return typeof window === `undefined`
}

export const isClient = () => {
  return typeof window !== `undefined`
}

// https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
export const isTouch = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')

  const mq = function (query) {
    let m = ''
    if (typeof window !== `undefined`) {
      m = window.matchMedia(query).matches
    }
    return m
  }

  if (typeof window !== `undefined`) {
    if (
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof DocumentTouch)
    ) {
      return true
    }
  }

  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  let ret = ''
  if (typeof window !== `undefined`) {
    ret = mq(query)
  }

  return ret
}

export const isMobile = () => {
  if (isClient()) return window.innerWidth <= 1024
}

export const isTablet = () => {
  if (isClient()) return window.innerWidth > 768 && window.innerWidth <= 1400
}
